import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { confirmPreviews } from "reducers/Confirm";
import { makeCreativePreviewPermanent } from "reducers/CreativePreviews";
import { Button } from "rhombus-react";
import { pluralize } from "utils/common";

export default function BulkPermanentPreviewsButton({ previews, disabled }) {
	const dispatch = useDispatch();
	const { libraryId } = useSelector(state => ({
		libraryId: state.libraryProperties.id,
	}));

	const mappedPermanentPreviews = previews.map(preview => ({ ...preview, isPermanent: true }));

	const plural = pluralize("", previews.length);
	const confirmProps = {
		libraryId,
		previews: mappedPermanentPreviews,
		title: `Confirm Making Preview${plural} Permanent`,
		commitLabel: "Make Permanent",
		desc: `Are you sure you want to make the following shared preview${plural} permanent?`,
		commitTheme: "blue",
	};

	const handleClick = () => {
		return dispatch(confirmPreviews(makeCreativePreviewPermanent, confirmProps, true));
	};

	return (
		<Button
			style="block"
			icon="fas fa-infinity"
			theme="blue"
			onClick={handleClick}
			disabled={disabled}
		>
			Make Permanent
		</Button>
	);
}
